<template>
  <div class="kpi-managers-register-page">
    <div v-if="true">
      <div class="title f v">
        <img src="https://j.weizan.cn/youxiang/kpi_register.png" />
        <!-- <div>{{activity.activity_name}}</div> -->
        <div class="f16">活动名称：{{actName}}</div>
      </div>
      <van-cell-group class="cell-group">
        <van-field v-model="confirmDetail.name" label="姓名" placeholder="请输入姓名" />
        <van-field
          v-model.number="confirmDetail.mobile"
          label="手机号"
          type="tel"
          maxlength="11"
          placeholder="请输入手机号"
        />
        <van-field
          label="验证码"
          v-model="confirmDetail.verifyCode"
          maxlength="4"
          placeholder="请输入验证码"
        >
          <van-button
            slot="button"
            size="small"
            type="primary"
            :disabled="timeOutCode!=60"
            @click="getSms"
          >{{timeOutCode==60?'获取验证码':`${timeOutCode}s`}}</van-button>
        </van-field>
        <van-field
          v-model="kpiUserTypeName"
          label="身份"
          readonly
          placeholder="请选择对应的身份"
          input-align="right"
          right-icon="arrow"
          @click="openType = true"
        />
        <van-field
            v-model="LegionName"
            label="所属军团"
            readonly
            placeholder="请选择对应的军团"
            input-align="right"
            right-icon="arrow"
            @click="openLegion = true"
        />
        <van-field
          v-model="BrandName"
          label="所属品牌"
          readonly
          placeholder="请选择对应的品牌"
          input-align="right"
          right-icon="arrow"
          @click="handleOpenBrand"
        />
        <van-field
          v-model="ShopName"
          v-if="showShop"
          label="所属门店"
          readonly
          placeholder="请选择对应的门店"
          input-align="right"
          right-icon="arrow"
          @click="openShopList"
        />
        <!-- <van-field
          v-model="mobile"
          label="所属军团"
          readonly
          placeholder="请选择对应的军团"
          input-align="right"
          right-icon="arrow"
          @click="openType = true"
        />-->
      </van-cell-group>
      <div class="sure-btn">
        <van-button type="info" @click="confirmcheck">确认</van-button>
      </div>
    </div>
    <!-- 选择品牌 -->
    <van-popup v-model="openBrand" position="bottom">
      <van-picker
        show-toolbar
        title="切换品牌"
        value-key="name"
        :columns="brandList"
        @cancel="openBrand = !openBrand"
        @confirm="confirmBrand"
      />
    </van-popup>
    <!-- 选择品牌 -->
    <van-popup v-model="openType" position="bottom">
      <van-picker
        show-toolbar
        title="切换品牌"
        :columns="columns"
        @cancel="openType = !openType"
        value-key="label"
        @confirm="confirmkpiUserType"
      />
    </van-popup>
    <!--选择军团-->
    <van-popup v-model="openLegion" position="bottom">
      <van-picker
          show-toolbar
          title="切换军团"
          value-key="name"
          :columns="legionList"
          @cancel="openLegion = !openLegion"
          @confirm="confirmLegion"
      />
    </van-popup>
    <van-popup v-model="openShop" position="bottom">
      <van-picker
        show-toolbar
        title="切换门店"
        :columns="ShopList"
        value-key="name"
        @cancel="openShop = !openShop"
        @confirm="confirmShop"
      />
    </van-popup>
    <van-dialog
      v-model="confirmOnce"
      title="信息确认"
      confirmButtonText="确认"
      cancelButtonText="修改"
      showCancelButton
      @confirm="confirmSec = true"
      confirm-button-color="orange"
    >
      <van-cell-group class="mt10 mb10">
        <van-field label="姓名" v-model="confirmDetail.name" readonly />
        <van-field label="手机" v-model="confirmDetail.mobile" readonly />
        <!-- <van-field label="所属军团" v-model="nodata" readonly /> -->
        <van-field label="身份" v-model="kpiUserTypeName" readonly />
        <van-field label="所属军团" v-model="LegionName" readonly />
        <van-field label="所属品牌" v-model="BrandName" readonly />
        <van-field label="所属门店" v-model="ShopName" readonly v-if="showShop" />
        <van-cell>
          <template #title>
            <div class="f fvc">
              <van-icon name="warning-o" size="40" color="orange" />
            </div>
          </template>
          <template #default>
            <div style="color:orange">提示：请核对您的身份信息和所属品牌是否正确。该信息将影响品牌业绩及奖金</div>
          </template>
        </van-cell>
      </van-cell-group>
    </van-dialog>
    <van-dialog
      v-model="confirmSec"
      title="信息确认"
      confirmButtonText="确认"
      cancelButtonText="修改"
      showCancelButton
      confirm-button-color="red"
      @confirm="saveBrandRegister"
    >
      <van-cell-group class="mt10 mb10">
        <van-field label="姓名" v-model="confirmDetail.name" readonly />
        <van-field label="手机" v-model="confirmDetail.mobile" readonly />
        <!-- <van-field label="所属军团" v-model="nodata" readonly /> -->
        <van-field label="身份" v-model="kpiUserTypeName" readonly />
        <van-field label="所属军团" v-model="LegionName" readonly />
        <van-field label="所属品牌" v-model="BrandName" readonly />
        <van-field label="所属门店" v-model="ShopName" readonly v-if="showShop" />
        <van-cell>
          <template #title>
            <div class="f fvc">
              <van-icon name="warning-o" size="40" color="red" />
            </div>
          </template>
          <template #default>
            <div style="color:red">提示：请核对您的身份信息和所属品牌是否正确。该信息将影响品牌业绩及奖金</div>
          </template>
        </van-cell>
      </van-cell-group>
    </van-dialog>

    <!--审核状态-->
    <!-- <van-popup v-model="examise_show" class="examise" v-if="user.id && loaded">
      <img src="https://j.weizan.cn/youxiang/images/null.jpg" alt=""/>
      <div>您的申请已提交</div>
      <div v-if="user.status === 1">正在审核中~</div>
      <div v-if="user.status === 3">审核不通过!!!</div>
    </van-popup>-->
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      columns: [
        { label: "品牌负责人", value: "brand" },
        { label: "导购员", value: "staff" },
      ],
      nodata: "San",
      confirmOnce: false,
      confirmSec: false,
      confirmed: false,
      openType: false,
      timeOutCode: 60,
      activity: {},
      user_id: 0,
      kpi_uid: 0,
      share_uid: 0,
      examise_show: false, // 审核
      user: {},
      loaded: false,
      name: "",
      mobile: "",
      confirmDetail: {
        catId: 0,
        actId: 0,
        brandId: 0,
        inviteId: 0,
        kpiUserType: "",
        mobile: "",
        name: "",
        // shopId: 0,品牌负责人不传
        userId: 0, //微信用户Id，看看是不是openId
        verifyCode: "",
      },
      brandList: [],
      legionList: [],
      ShopList: [],
      openBrand: false,
      openLegion: false,
      BrandName: "",
      LegionName: '全部',
      kpiUserTypeName: "",
      showShop: false,
      ShopName: "",
      openShop: false,
    };
  },
  mounted() {
    // http://wx.youxiangzb.com/#/managersregister?act_id=1&inviteId={\"id\":7}
    this.confirmDetail.actId = Number(this.$route.query.act_id); //活动Id
    this.confirmDetail.inviteId = Number(this.$route.query.inviteId); //邀请人Id
    this.confirmDetail.userId = Number(localStorage.getItem("user_id")); //微信Id
    this.getAllBrands();
    this.getLegionList();
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  computed: {
    ...mapState(["actName"]),
  },
  methods: {
    handleOpenBrand () {
      this.openBrand = true
    },
    // 获取军团列表
    getLegionList () {
      this.legionList = [{name: '全部', id: 0}];
      this.$kpi.achieve.getLegionList({
        "actId": this.confirmDetail.actId,
        "page": -1,
        "size": -1
      }).then((res) => {
        console.log(res)
        if(res.code==0){
          var data=res.data;
          this.legionList = data.list;
          this.legionList.push({name: '全部', id: 0});
          if (data.list.length < 1) {
            this.openLegion = false;
            this.$toast("暂无更多军团");
          }
        }else if(res.code==10200){
          this.openLegion = false;
          this.$toast("暂无更多军团");
        }
      });
    },
    // 获取注册验证码
    async getSms() {
      if (!this.isPhone(this.confirmDetail.mobile)) {
        this.$toast("请填写正确手机号");
        return;
      }
      let res = await this.$http.post(`/v1/home/send_code`, {
        phone: this.confirmDetail.mobile,
        use: "register",
      });
      console.log(res);
      if (res.code == 0) {
        this.$toast("发送成功！");
        this.timeDjs();
      }
    },
    // 注册操作
    async saveBrandRegister() {
      let res = await this.$http.post(
        `/v1/kpiuser/register`,
        this.confirmDetail
      );
      console.log(res);
      if (res.data && res.code == 0) {
        // this.$toast("注册成功！");
        this.SaveDetail();
      }
    },
    isPhone(phone) {
      var bValidate = RegExp(
        /^(0|86|17951)?(13[0-9]|16[0-9]|15[012356789]|18[0-9]|17[0-9]|19[0-9]|14[57])[0-9]{8}$/
      ).test(phone);
      if (bValidate) {
        return true;
      } else {
        return false;
      }
    },
    // 根据活动ID获取品牌列表
    getAllBrands() {
      this.$http
        .post("/v1/achievement/brand/list", {
          actId: this.confirmDetail.actId,
          catId: this.confirmDetail.catId || null,
          // actId: 1,
          name: "",
          page: -1,
          size: -1,
        })
        .then((res) => {
          this.brandList = res.data? res.data.list : [];
        });
    },
    // 确认选择军团
    confirmLegion(value) {
      this.LegionName = value.name || '';
      this.confirmDetail.catId = value.id || null;
      this.openLegion = false;
      this.confirmDetail.brandId = null;
      this.BrandName = '';
      this.getAllBrands()
    },
    // 确认选择品牌
    confirmBrand(value) {
      console.log(value);
      this.confirmDetail.brandId = value.id;
      this.BrandName = value.name;
      this.confirmDetail.shopId = "";
      this.ShopName = "";
      this.openBrand = false;
    },
    // 确认选择门店
    confirmShop(value) {
      console.log(value);
      this.confirmDetail.shopId = value.id;
      this.ShopName = value.name;
      this.openShop = false;
    },
    // 确认选择身份
    confirmkpiUserType(value) {
      console.log(value);
      this.kpiUserTypeName = value.label;
      this.confirmDetail.kpiUserType = value.value;
      this.openType = false;
      // 如果选择员工则显示门店选项
      if (value.value == "staff") {
        this.showShop = true;
      } else {
        // 根据是否staff传shopId
        this.showShop = false;
      }
    },
    // 根据品牌ID获取门店列表
    openShopList() {
      if (this.confirmDetail.brandId) {
        this.$http
          .post("/v1/achievement/shop/list", {
            actId: this.confirmDetail.actId,
            // actId: 1,
            brandId: this.confirmDetail.brandId,
            name: "",
            page: 1,
            size: -1,
          })
          .then((res) => {
            console.log(res);
            this.ShopList = res.data.list;
            if (this.ShopList && this.ShopList.length == 0) {
              this.$toast("当前品牌并未设置门店，请先联系活动负责人添加");
            } else {
              this.openShop = true;
            }
          });
      } else {
        this.$toast("请先选择品牌");
      }
    },
    confirmcheck() {
      let act = JSON.parse(JSON.stringify(this.confirmDetail));
      if (!act.name) {
        this.$toast("请填写您的姓名");
        return;
      }
      if (!this.isPhone(act.mobile)) {
        this.$toast("请填写正确手机号");
        return;
      }
      if (!act.verifyCode) {
        this.$toast("请填写验证码");
        return;
      }
      if (this.PhoneSms(act.verifyCode) == false) {
        this.$toast("验证码应为4位数字");
        return;
      }
      if (!this.kpiUserTypeName) {
        this.$toast("请选择身份");
        return;
      }
      if (!act.brandId) {
        this.$toast("请选择所属品牌");
        return;
      }
      if (this.kpiUserTypeName == "导购员" && !act.shopId) {
        this.$toast("请选择所属门店");
        return;
      }
      this.confirmOnce = true;
    },
    PhoneSms(val) {
      return /^\d{0,4}$/.test(val);
    },
    async SaveDetail() {
      this.$router.push({
        path: "/registering",
        query: {
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
    timeDjs() {
      --this.timeOutCode;
      this.timer = setInterval(() => {
        --this.timeOutCode;
        if (this.timeOutCode == 0) {
          clearInterval(this.timer);
          this.timeOutCode = 60;
        }
      }, 1000);
    },
    //发送验证码
    async SendSms() {
      this.$toast("发送成功");
      this.timeDjs();
    },
    /**
     * 表单验证
     * @returns {*}
     */
    validate() {
      if (!this.name) {
        return this.$fn.toast("请输入姓名");
      }
      if (!this.mobile) {
        return this.$fn.toast("请输入手机号");
      }
      return true;
    },
  },
};
</script>

<style lang="less" scoped>
.kpi-managers-register-page {
  .title {
    /*头部*/
    background-color: #ffffff;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    flex: 1;
    font-weight: bold;
    img {
      width: 100%;
      // height: 90px;
    }
    div {
      width: 100%;

      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;
      padding-top: 10px;
    }
  }
  .tip {
    font-weight: bold;
    padding: 10px 15px;
  }

  .van-cell__title {
    max-width: 90px;
  }
  .van-cell__value {
    text-align: left;
  }
  .sure-btn {
    text-align: center;
    margin: 40px 15px;
    button {
      width: 100%;
    }
  }
  .examise {
    /*审核提示*/
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    img {
      width: 120px;
      height: 110px;
      margin-bottom: 20px;
    }
  }
}
</style>
